import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const FactoryIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"factory"} ref={ref}/>
});

FactoryIcon.displayName = "FactoryIcon";
